import React from 'react';
import SvgIcon from './SvgIcon';

const Avalanche = props => (
    <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
        <path
            d="M2.25.5l1.494.6a2 2 0 011.218 1.462l.7 3.472c.061.306.193.594.386.84l8.4 10.737a2 2 0 01.392.875l.7 3.835a1 1 0 01-.984 1.179H2.25M17.1 5.379a.5.5 0 00-.482-.131l-1.859.492a.5.5 0 00-.355.353l-.5 1.855a.5.5 0 00.128.483L15.386 9.8a.5.5 0 00.483.131l1.858-.492a.5.5 0 00.355-.352l.5-1.856a.5.5 0 00-.127-.483L17.1 5.379zM16.7 13.705a.5.5 0 00-.482-.131l-.758.2a.5.5 0 00-.355.353l-.205.756a.5.5 0 00.128.484l.552.556a.5.5 0 00.483.131l.758-.2a.501.501 0 00.355-.352l.205-.757a.5.5 0 00-.128-.483l-.553-.557zM11.2 5.577a.5.5 0 00-.482-.131l-.758.2A.5.5 0 009.608 6l-.208.756a.5.5 0 00.128.483l.552.556a.5.5 0 00.483.131l.758-.2a.5.5 0 00.355-.353l.205-.756a.5.5 0 00-.128-.484l-.553-.556zM21.683 22.3a.5.5 0 000-.5l-.548-.948a.5.5 0 00-.433-.25h-1.1a.5.5 0 00-.433.25l-.548.948a.5.5 0 000 .5l.548.949a.5.5 0 00.433.25h1.1a.5.5 0 00.433-.25l.548-.949zM12.077 2a.25.25 0 110 .5.25.25 0 010-.5zM20.827 11.75a.25.25 0 110 .5.25.25 0 010-.5zM20.327 16.5a.25.25 0 110 .5.25.25 0 010-.5z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

Avalanche.displayName = 'AvalancheIcon';

export default Avalanche;
